import React, { PropsWithChildren } from 'react'

import { bemJoin } from '@app/lib/bem'

import './HighlightedResult.scss'

export type Props = {
  isOk: boolean
}

export const HighlightedResult = ({ isOk, children }: PropsWithChildren<any>) => {
  const b = bemJoin('highlighted-result')

  return <span className={b({ [isOk ? 'ok' : 'not-ok']: true })}>{children}</span>
}
